import { TableCell, TableRow } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { TooltippedTruncatedText } from '~/components/TooltippedTruncatedText';

import { useSxStyles } from './useStyles';

export interface MyPerformanceProps {}

export const TableHeader: React.FC<MyPerformanceProps> = () => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();
  return (
    <TableRow>
      <TableCell sx={{ ...sxStyles.cell, ...sxStyles.avatarCell }} />
      <TableCell sx={sxStyles.cell} />
      <TableCell align="right" sx={sxStyles.cell} data-cy="score">
        <TooltippedTruncatedText>
          {t<string>('latestScore')}
        </TooltippedTruncatedText>
      </TableCell>
      <TableCell align="right" sx={sxStyles.cell} data-cy="scoreV2">
        <TooltippedTruncatedText>
          {t<string>('latestScoreV2')}
        </TooltippedTruncatedText>
      </TableCell>
      <TableCell align="right" sx={sxStyles.cell} data-cy="appraisal">
        <TooltippedTruncatedText>
          {t<string>('laAppraisalDiscussion')}
        </TooltippedTruncatedText>
      </TableCell>
      <TableCell align="right" sx={sxStyles.cell} data-cy="appraisal-status">
        <TooltippedTruncatedText>
          {t<string>('laStatus')}
        </TooltippedTruncatedText>
      </TableCell>
      <TableCell align="right" sx={sxStyles.cell} data-cy="appraisal-modified">
        <TooltippedTruncatedText>
          {t<string>('laModifiedTime')}
        </TooltippedTruncatedText>
      </TableCell>
    </TableRow>
  );
};
